export const ScheduleMeetingFormDataKey = Symbol('ScheduleMeetingFormDataKey');
export const UpdateScheduleMeetingFormKey = Symbol('UpdateScheduleMeetingFormKey');
export const ScheduleMeetingPersonDataKey = Symbol('ScheduleMeetingPersonData');
export const ScheduleMeetingRequestStatusKey = Symbol('RequestStatusKey');
export const ScheduleACallButtonClicked = Symbol('ScheduleACallButtonClicked');
export const CloseScheduleModalKey = Symbol('CloseScheduleModal');

export const toastKey = Symbol('toast');
